import { PropsWithChildren, createContext, useContext, useMemo } from 'react';

type TContext = {
  useDisabledResource: (resource: 'cpu' | 'memory') => boolean;
};
const ResourceContext = createContext<TContext>({
  useDisabledResource: () => false,
});

export const ResourceProvider = ({
  children,
  useDisabledResource,
}: PropsWithChildren<{
  useDisabledResource: TContext['useDisabledResource'];
}>) => {
  return (
    <ResourceContext.Provider
      value={useMemo(() => ({ useDisabledResource }), [useDisabledResource])}
    >
      {children}
    </ResourceContext.Provider>
  );
};

export const useResource = () => useContext(ResourceContext);
